<template>
  <div class="base-table-wrapper">
      <div class="contentSection zebra">
        <div class="row d-flex flex-row-reverse">
          <button v-if="downloadCsv" class="export-csv pointer mb-2 " @click="exportTableToCSV(`${today}.csv`)">Download CSV</Button>
        </div>
        <div class="row">
          <div
            :class="[column.class, 'tableHead', 'col']"
            v-for="(column, index) in columns"
            :key="index">
            {{column.name}}
          </div>
        </div>
        <div :class="['row', 'download-data-row', { 'last-row-bold': totals }]" v-for="(row, index) in tableData" :key="index">
          <div v-for="(column, key) in columns" :key="key" :class="[column.class, 'col']">
            <slot :name="column.key" :row="row">
              {{ column.filter ? $options.filters[column.filter](row[column.key]) : row[column.key] || column.fallback }}
            </slot>
          </div>
        </div>
      </div>
    <BasePaginate
      v-if="pagination"
      :pagination="pagination"
      :request-params="paginationParams"
      :onChangedPage="indexCallback"
    />
  </div>
</template>
<script>
import moment from 'moment'

export default {
  data () {
    return {
      today: moment().format('MM:DD:YYYY')
    }
  },
  props: {
    columns: { type: Array, required: true },
    tableData: { type: Array, required: true },
    pagination: { type: Object, required: false, default: null },
    paginationParams: { type: Object, required: true },
    indexCallback: { type: Function, required: true },
    downloadCsv: { type: Boolean, required: false, default: false },
    totals: { type: Boolean, required: false, default: false }
  },
  mounted () {
  },
  methods: {
    downloadCSV (csv, filename) {
      var csvFile
      var downloadLink
      csvFile = new Blob([csv], { type: 'text/csv' })
      downloadLink = document.createElement('a')
      downloadLink.download = filename
      downloadLink.href = window.URL.createObjectURL(csvFile)
      downloadLink.style.display = 'none'
      document.body.appendChild(downloadLink)
      downloadLink.click()
    },
    exportTableToCSV (filename) {
      // this does not handle paginated data.
      let csv = []
      let rows = document.querySelectorAll('.download-data-row')
      let header = []
      for (let i = 0; i < this.columns.length; i++) {
        const headerCol = this.columns[i]
        header += headerCol.name + ','
      }
      csv.push(header)
      for (var i = 0; i < rows.length; i++) {
        var row = []
        var cols = rows[i].querySelectorAll('.col')
        for (var j = 0; j < cols.length; j++) {
          row.push(cols[j].innerText)
        }
        csv.push(row.join(','))
      }
      // Download CSV file
      this.downloadCSV(csv.join('\n'), filename)
    }
  }
}
</script>
<style lang="scss" scoped>
.export-csv{
  border: none;
  color: $mainColor !important;
}
.base-table-wrapper {
  margin: 0px;
  padding: 0px;
}
.last-row-bold:last-child {
    font-weight: bold;
}
</style>
